import '../../Common.scss';
import './ProgressTab.scss';
import { Loader } from '@trackman/web-shared-components';
import { useState } from 'react';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { useTranslation } from 'react-i18next';
import Subtitle from 'components/TextComps/Subtitle';
import { SelectClass } from 'pages/Organization/components/SelectClass/SelectClass';
import { SelectModule } from 'pages/Organization/components/Progress/SelectModule/SelectModule';
import { StudentsSearchInput } from 'pages/Organization/components/StudentsSearch/StudentsSearch';
import { ModuleProgress } from 'pages/Organization/components/Progress/ModuleProgress/ModuleProgress';
import { useGetClasses } from 'queryHooks/Organization/Classes/useGetClasses';
import { useGetOrganizationProgressModuleList } from 'queryHooks/Organization/Progress/useGetOrganizationProgressModuleList';
import NoClassesFound from 'pages/Organization/components/NoClassesFound/NoClassesFound';

export const ProgressTab = () => {
  const { t } = useTranslation();

  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);
  const [selectedClassId, setSelectedClassId] = useState<string>('');
  const [selectedModuleId, setSelectedModuleId] = useState<string>('');
  const [selectedProgressOverviewIndex, setSelectedProgressOverviewIndex] = useState<number>(0);
  const [searchStudentsInputValue, setSearchStudentsInputValue] = useState<string>('');

  const { data: moduleList, isPending } = useGetOrganizationProgressModuleList((selectedModuleId) => setSelectedModuleId(selectedModuleId));

  const { data: classesList, isPending: isClassesListPending } = useGetClasses(
    selectedOrganizationId,
    false,
    (id) => setSelectedClassId(id)
  );

  return (
    <>
      {isPending && !selectedModuleId ? (
        <div className='new-loader-wrapper'>
          <Loader size='large' />
        </div>
      ) : (
        <>
          {!isClassesListPending && !classesList?.length ? (
            <NoClassesFound />
          ) : (
            <>
              <div className='tab-searchbar-section'>
                <Subtitle>{t('StudentAndClassProgress', { ns: 'organizationPage' })}</Subtitle>
                <div className='filters'>
                  <SelectClass
                    onChange={(newValue) => setSelectedClassId(newValue)}
                    value={selectedClassId ?? ''}
                    classesList={classesList ?? []}
                  />
                  <SelectModule
                    moduleList={moduleList ?? []}
                    selectedModuleId={selectedModuleId}
                    selectModule={(moduleId) => setSelectedModuleId(moduleId)}
                  />
                  {selectedProgressOverviewIndex === 0 && (
                    <div className='students-search-input-wrapper'>
                      <StudentsSearchInput
                        label={t('SearchForStudents', { ns: 'organizationPage' }) as string}
                        value={searchStudentsInputValue}
                        onChange={(newValue) => setSearchStudentsInputValue(newValue)}
                      />
                    </div>
                  )}
                </div>
              </div>

              <ModuleProgress
                selectedClassId={selectedClassId}
                selectedModuleId={selectedModuleId}
                selectedModuleName={moduleList?.find((module) => module.id === selectedModuleId)?.title ?? ''}
                isModuleProgressQueryEnabled={!!selectedClassId && !!selectedModuleId}
                selectedProgressOverviewIndex={selectedProgressOverviewIndex}
                setSelectedProgressOverviewIndex={setSelectedProgressOverviewIndex}
                studentsFilter={searchStudentsInputValue}
              />
            </>
          )}
        </>
      )}
    </>
  );
};
